import React, { useState } from "react";
import classnames from "classnames";
import AppSnippet from "../../lib/AppSnippet";
import cssClass from "./listStyles.module.scss";

const ExpandableList = ({ title, stringArray }) => {
  const UNEXPANDED_LIST_LENGTH = 3;
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={cssClass.container} aria-expanded={expanded}>
      {title && <p className="boldText">{title}</p>}
      <ul className={cssClass.list}>
        {stringArray.map((string, i) => (
          <li
            key={string}
            className={classnames({
              [cssClass.hidden]: i > UNEXPANDED_LIST_LENGTH - 1 && !expanded,
            })}
            aria-hidden={UNEXPANDED_LIST_LENGTH - 1 && !expanded}
          >
            {string}
          </li>
        ))}
      </ul>
      {stringArray.length > UNEXPANDED_LIST_LENGTH && (
        <button
          onClick={() => setExpanded(!expanded)}
          className={cssClass.showAllButton}
        >
          {expanded ? (
            <AppSnippet snippet="showLess" />
          ) : (
            <AppSnippet snippet="showAll" />
          )}
          {/* TODO: window expands upwards sometimes??? */}
        </button>
      )}
    </div>
  );
};

export default ExpandableList;
